import { useState, useEffect } from 'react';
import styled from '@emotion/styled';

import { Grid, Card, CardHeader, CardContent, CardActions, Button, Typography, IconButton, Icon } from '@mui/material';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import NoItemsFound from '../../../utils/NoItems';

import MultiStatusChip from '../../../utils/utilities/MultiStatusChip';

import Face2RoundedIcon from '@mui/icons-material/Face2Rounded';
import TodayRoundedIcon from '@mui/icons-material/TodayRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded';

import NoTimeline from '../../../utils/utilities/Timeline/NoTimeline';

import { BasicFlex, ScrollableContainer } from '../../../utils/Common';

import { formatGenericDate, formatGenericTime } from '../../../utils/util';

import { useQuery } from '@tanstack/react-query';

import FormDialog from '../../../utils/utilities/Dialog';
import EditSchedule from '../../Schedule/EditSchedule';

// new Event context
import { useNewEvent } from '../../../contexts/NewEvent';

// use pageData context
import { usePageData } from '../../../contexts/PageData';

// apiService
import { getAppointmentsByCustomer } from '../apiService';

import AppointmentCard from '../Components/AppointmentCard';

const AppointmentList = styled.div`
  display: flex;
  /* flex-direction: column; */
  gap: 1rem;
  flex-wrap: wrap;
`

const PastCard = styled(Card)`
  padding: 0;
  min-width: 25rem;
  flex-grow: 1;
`

const ExpandBar = styled(BasicFlex)`

`

const MoreInfo = styled(CardBlockContainer)`
  margin-bottom: 1rem;
`

const AppointmentTab = () => {
  const { data = {} } = usePageData();

  console.log(data, "data&&&&&&&&&&&&&&&");

  const [expanded, setExpanded] = useState(new Set());

  const { event, setEvent, openDialog, setOpenDialog } = useNewEvent();

  const toggleExpand = (id) => {
    const newExpanded = new Set(expanded);
    if (newExpanded.has(id)) {
      newExpanded.delete(id);
    } else {
      newExpanded.add(id);
    }
    setExpanded(newExpanded);
  }

  const { data: appointments } = useQuery({
    queryKey: ['appointments', 'customer', data?.customer_id],
    queryFn: () => getAppointmentsByCustomer(data?.customer_id),
    enabled: !!data?.customer_id
  })

  return (
    <>
    <Grid container spacing={3}>
      
      <Grid size={{xs: 12, md: 6}}>
        <Card variant='outlined'>
          <CardHeader title="Active Appointments" />
          <CardContent>
            {/* <CardBlockContainer> */}
            <BasicFlex dir="column" gap="1.5rem">
              {appointments?.active?.length ? appointments.active.map((appt, i) => (
                <AppointmentCard key={appt.appointment_id} event={appt} />
               ))  : null}
            </BasicFlex>
            {/* </CardBlockContainer> */}
          </CardContent>
        </Card>
      </Grid>

      <Grid size={{xs: 12, md: 6}}>
        <Card variant='outlined'>
          <CardHeader title="Appointment History" />
          <CardContent>
              {appointments?.past?.length ? (
                <ScrollableContainer $noBorder $height="25rem">
                  <AppointmentList>
                  {appointments?.past.map((appt, i) => (
                  <PastCard key={appt.appointment_id} variant='outlined' >
                    <CardHeader sx={{pb: 0}} title={appt?.title} subheader={formatGenericDate(appt?.appointment_date)} action={<MultiStatusChip value={appt.status} values={[{value: "scheduled", label: "Scheduled", status: "primary"}, {value: "in_progress", label: "In Progress", status: "warning"}, {value: "completed", label: "Show", status: "success"}, {value: "no_show", status: "error"}, {value: "cancelled", label: "Cancelled", status: "error"}]} />} />
                    <CardContent sx={{py: '.2rem !important'}}>
                      <ExpandBar justify="flex-end">
                        <IconButton size="small" color="basic" onClick={() => toggleExpand(appt.appointment_id)}>
                          <MoreHorizRoundedIcon />
                        </IconButton>
                      </ExpandBar>
                    {expanded.has(appt.appointment_id) && <MoreInfo>
                        <CardBlock icon={<Face2RoundedIcon fontSize="small" />} info={appt.stylist} spread="2rem" />
                        <CardBlock icon={<TodayRoundedIcon fontSize="small" />} info={`${formatGenericTime(appt?.start_time)} - ${formatGenericTime(appt?.end_time)}`} spread="2rem" />
                        <CardBlock icon={<AccessTimeRoundedIcon fontSize="small" />} info={`${appt?.duration_in_minutes} minutes`} spread="2rem" />
                      </MoreInfo> }
                    </CardContent>
                  </PastCard>
                ))}
                </AppointmentList>
              </ScrollableContainer>
            ) : <NoTimeline title="No Appointment History" subtitle="Appointment history will appear here as they are updated" /> }
          </CardContent>
        </Card>
      </Grid>

      {openDialog ? <FormDialog size="xl" title="Schedule Appointment" forceOpen={openDialog} forceClose={() => setOpenDialog(false)} text="" saveText="Add New Appointment" saveFunc={() => {}} useForm={true}>
        <EditSchedule dialog={true} event={event} />
      </FormDialog> : null}
    </Grid>
    </>
  );

};

export default AppointmentTab;